import * as actionTypes from "./actionTypes";

export function getUser(User: IUser) {  
  const action: UserAction = {
    type: actionTypes.GET_USER,
    user: User
  };
  return dispatchRequest(action);
}

export function setUser(User: IUser) {
  const action: UserAction = {
    type: actionTypes.SET_USER,
    user: User
  };
  return dispatchRequest(action);
}

export function removeUser(User: IUser) {
  const action: UserAction = {
    type: actionTypes.REMOVE_USER,
    user: User
  };
  return dispatchRequest(action);
}

export function dispatchRequest(action: UserAction) {
  return (dispatch: DispatchType) => {   
      dispatch(action);   
  };
}
